import {
    OperatorKeepItem,
    UserKeepItem,
} from '@/services/dtos/accessRequest.dto';
import { Check, CheckCircle2 } from 'lucide-react';
import { ACCESS_SECTION_MESSAGES } from './access-section-messages';

interface ReusedAccessSectionProps {
    users: UserKeepItem[];
    operators: OperatorKeepItem[];
}

export function ReusedAccessSection({
    users,
    operators,
}: ReusedAccessSectionProps) {
    const total = users.length + operators.length;

    return (
        <div className="space-y-4">
            <div className="flex items-center gap-2">
                <CheckCircle2 className="h-5 w-5 text-green-600" />
                <h3 className="text-lg font-medium">
                    {ACCESS_SECTION_MESSAGES.REUSED.TITLE}
                </h3>
            </div>
            {total === 0 ? (
                <p className="text-sm text-gray-500 italic">
                    {ACCESS_SECTION_MESSAGES.REUSED.EMPTY}
                </p>
            ) : (
                <div className="grid gap-2 text-sm">
                    {users.length > 0 && (
                        <div className="flex items-center gap-1.5">
                            <Check className="h-4 w-4 text-green-700 shrink-0" />
                            <span>
                                <span className="font-medium text-green-700">
                                    {ACCESS_SECTION_MESSAGES.REUSED.USERS_LABEL}
                                </span>
                                {users.map(u => u.suffix).join(', ')}
                            </span>
                        </div>
                    )}
                    {operators.length > 0 && (
                        <div className="flex items-center gap-1.5">
                            <Check className="h-4 w-4 text-green-700 shrink-0" />
                            <span>
                                <span className="font-medium text-green-700">
                                    {ACCESS_SECTION_MESSAGES.REUSED.OPERATORS_LABEL}
                                </span>
                                {operators.map(o => o.pair).join(', ')}
                            </span>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
